/* AlloSwitch pop-up: no third-party scripts, network requests, or tracking. */
(function () {
  "use strict";
  function boot() {
    document.querySelectorAll("dialog[data-allo-promo]").forEach(function (dialog) {
      if (dialog.dataset.initialized === "true") return;
      dialog.dataset.initialized = "true";
      var key = dialog.dataset.storeKey || "allo-promo";
      var ttl = Math.max(1, Number(dialog.dataset.repeatDays) || 7) * 86400000;
      var delay = Math.max(0, Number(dialog.dataset.delay) || 10000);
      var force = new URLSearchParams(location.search).get("allo_popup_preview") === "1";
      var isEditor = Boolean(window.Shopify && window.Shopify.designMode);
      var isMobileOnly = dialog.dataset.mobileOnly === "true";
      var handle = null;
      function savedTime() {
        try { return Number(localStorage.getItem(key)) || 0; }
        catch (e) { return 0; }
      }
      function remember() {
        if (force || isEditor) return;
        try { localStorage.setItem(key, String(Date.now())); }
        catch (e) {}
      }
      function open() {
        if (dialog.open || typeof dialog.showModal !== "function") return;
        if (isMobileOnly && !matchMedia("(max-width: 749px)").matches) return;
        if (!force && !isEditor && Date.now() - savedTime() < ttl) return;
        dialog.showModal();
      }
      function close() {
        remember();
        if (dialog.open) dialog.close();
      }
      dialog.querySelectorAll("[data-allo-promo-close]").forEach(function (button) {
        button.addEventListener("click", close);
      });
      dialog.addEventListener("cancel", function () { remember(); });
      dialog.addEventListener("click", function (event) {
        if (event.target === dialog) close();
      });
      dialog.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", remember);
      });
      if (force) open();
      else if (!isEditor && !["/cart", "/checkout"].some(function (path) { return location.pathname.startsWith(path); })) {
        handle = setTimeout(function () { handle = null; open(); }, delay);
      }
      if (isEditor) {
        document.addEventListener("shopify:section:select", function (event) {
          if (event.detail && dialog.id.indexOf(event.detail.sectionId) >= 0) open();
        });
        document.addEventListener("shopify:section:deselect", function (event) {
          if (event.detail && dialog.id.indexOf(event.detail.sectionId) >= 0 && dialog.open) dialog.close();
        });
      }
      window.addEventListener("pagehide", function () { if (handle !== null) clearTimeout(handle); }, {once: true});
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
